import React, { useEffect, useMemo, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import { toast } from "react-toastify";
import ScrollableReactTable from "@components/ScrollableDatatable";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import Notfound from "@components/Not-Found";
import moment from "moment";
import { adminBulkLocationUpdateStatus } from "@services/location.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import {
  exportManageAudit,
  generateManageAuditVendorReport,
  getManageAuditScore,
  getManageAuditScoreFilter,
} from "@services/audit.service";
import CalenderDropdown from "@_common/CalenderDropdown";
import ManageAuditFilterForm from "@components/common/ManageAuditFilterForm";
import { formatText } from "@_common/format-text";
import { useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { convertDate, currentDate } from "@_common/date-helpers";
import { tableScoreColors } from "@_common/colors";
import { countKeysWithValues, numberFormatter } from "@_common/text-helpers";
//graph module
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import FooterWrapper from "@components/common/FooterWrapper";
import MenuAuditSvgComponent from "../../../assets/svg-components/left-menu/menuadit";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import ManageAuditNotfound from "@components/Page-Not-Found/manage-audit-not-found";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { getVendorCheckpointsAllDocuments } from "@services/checkpoint.service";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ChartDataLabels
);
interface IManageAuditProps {}

const ManageAuditVendor: React.FunctionComponent<IManageAuditProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let mainParams = useParams();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      setDate(new Date());
      getRegionsList("", "");
    }
    getInfo();
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
      //-----------------region & group-----------------//
      if (getValue(params, `region_id`, "")) {
        getRegionsList("", getValue(params, `region_id`, ""));
        getGroupsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, "")
        );
      } else {
        getRegionsList("", getValue(params, `region_id`, ""));
      }
      //-----------------state-----------------//

      if (getValue(params, `group_id`, "")) {
        getStatesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, "")
        );
      }

      //-----------------city-----------------//

      if (getValue(params, `state_id`, "")) {
        getCitiesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, "")
        );
      }

      //-----------------location-----------------//
      if (getValue(params, `group_id`, "")) {
        getLocationsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, "")
        );
      }
      //-----------------vendor-----------------//
      if (getValue(params, `location_id`, "")) {
        getVendorList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, "")
        );
      }
      //-----------------audit type-----------------//
      if (getValue(params, `vendor_id`, "")) {
        getAuditTypeList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, ""),
          getValue(params, `audit_type`, "")
        );
      }
      setRequest({
        ...request,
        region_id: getValue(params, `region_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        city_id: getValue(params, `city_id`, ""),
        group_id: getValue(params, `group_id`, ""),
        location_id: getValue(params, `location_id`, ""),
        vendor_id: getValue(params, `vendor_id`, ""),
        audit_type: getValue(params, `audit_type`, ""),
      });
      if (getValue(params, `region_id`, "")) {
        setFilterVisibility(true);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const [selectedOption, setSelectedOption] = useState({});
  const getInfo = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: params.region_id,
        group_id: params.group_id,
        location_id: params.location_id,
        type: "LOCATION",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        // setSelectedOption(getValue(resp, `data.vendors_checkpoint[${0}]`, {}));
        if (params.location_id) {
          setSelectedOption(
            getValue(resp, `data.vendors_checkpoint[${0}]`, {})
          );
        } else {
          setSelectedOption({ location_id: 0, location_name: "All" });
        }
      }
    } catch (error) {}
  };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      type: params.type ? params.type : "VENDOR",
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: true,
      user_id: getValue(user, `id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getManageAuditScore(queryRequest);
      if (resp) {
        //------------------- Graph Section starts -------------------//
        let labelArray = getValue(resp, `data`, []).map(
          (item: any) => item.vendor_name
        );
        let submittedArray = getValue(resp, `data`, []).map((item: any) =>
          parseInt(item.uploaded)
        );
        let notSubmittedArray = getValue(resp, `data`, []).map((item: any) =>
          parseInt(item.not_uploaded)
        );
        let totalCheckpointArray = getValue(resp, `data`, []).map((item: any) =>
          parseInt(item.total_checkpoint)
        );
        // let headcount = getValue(resp, `data`, []).map((item: any) =>
        //   parseInt(item.manpower)
        // );
        let scoreArray = getValue(resp, `data`, []).map(
          (item: any) => `${parseFloat(item.score)}`
        );
        setValue(chartData, `labels`, labelArray);
        setValue(chartData, `datasets[${0}].data`, submittedArray);
        setValue(chartData, `datasets[${1}].data`, notSubmittedArray);
        setValue(chartData, `datasets[${2}].data`, totalCheckpointArray);
        // setValue(chartData, `datasets[${2}].data`, headcount);
        setValue(chartData, `datasets[${3}].data`, scoreArray);
        setChartData({ ...chartData });

        //------------------- Graph Section Ends -------------------//
        setList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            created_at: moment(getValue(item, `created_at`, "")).format(
              "DD MMM YYYY"
            ),
            absent_sites: formatText(getValue(item, `absent_sites`, "")),
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            city_name: getValue(item, `city.name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (row: object) => {
    // console.log(getValue(obj, `original`, ""));
    // navigate(
    //   `/audit/manage-audit/checkpoint/${getValue(
    //     params,
    //     `region_id`,
    //     ""
    //   )}/${getValue(params, `group_id`, "")}/${getValue(
    //     params,
    //     `location_id`,
    //     ""
    //   )}/${getValue(row, `original.vendor_id`, "")}?${mainQueryRequest}`
    // );
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  const searchParams = new URLSearchParams(window.location.search);
  const paramsNew = Object.fromEntries(searchParams.entries());

  const dateParam = paramsNew?.date ? new Date(paramsNew.date) : new Date(); // Get the date from params or use the current date
  // Helper function to get the month name for a given date
  // const getMonthName = (date: Date, offset: number) => {
  //   const adjustedDate = new Date(date);
  //   adjustedDate.setMonth(date.getMonth() - offset); // Subtract months to get the previous month
  //   return adjustedDate.toLocaleString("default", { month: "short" }); // Get month name
  // };

  // const currentMonthName = getMonthName(dateParam, 0);
  // const prevMonth1Name = getMonthName(dateParam, 1);
  // const prevMonth2Name = getMonthName(dateParam, 2);
  // const prevMonth3Name = getMonthName(dateParam, 3);

  const getMonthNameWithYear = (date: Date, offset: number) => {
    const adjustedDate = new Date(date);
    adjustedDate.setMonth(date.getMonth() - offset); // Subtract months to get previous month
    const month = adjustedDate.toLocaleString("default", { month: "short" });
    const year = adjustedDate.getFullYear().toString().slice(-2);
    return `${month}-${year}`;
  };

  // Use the new function to get month-year combinations
  const currentMonthName = getMonthNameWithYear(dateParam, 0);
  const prevMonth1Name = getMonthNameWithYear(dateParam, 1);
  const prevMonth2Name = getMonthNameWithYear(dateParam, 2);
  const prevMonth3Name = getMonthNameWithYear(dateParam, 3);

  const columns = React.useMemo(
    () => [
      {
        Header: "Vendor Name",
        accessor: "vendor_name",
        width: 150,
        // Cell: ({ row }: any) => {
        //   return (
        //     <>
        //       <NavLink
        //         to={`/audit/manage-audit/checkpoint/${getValue(
        //           params,
        //           `region_id`,
        //           ""
        //         )}/${getValue(params, `group_id`, "")}/${getValue(
        //           params,
        //           `location_id`,
        //           ""
        //         )}/${getValue(
        //           row,
        //           `original.vendor_id`,
        //           ""
        //         )}?${mainQueryRequest}`}
        //       >
        //         {row.values.vendor_name}
        //       </NavLink>
        //     </>
        //   );
        // },

        Cell: ({ row }: any) => {
          const vendor_id = row.original.vendor_id;
          //   const updatedQueryRequest = mainQueryRequest
          //   .split("&")
          //   .filter(param => !param.startsWith("view_type="))
          //   .join("&");

          // const finalQueryRequest = `${updatedQueryRequest}&vendor_id=${vendor_id}`;
          const updatedQueryRequest = `${mainQueryRequest}&vendor_id=${vendor_id}`;

          return (
            <NavLink
              to={`/audit/manage-audit/checkpoint?${updatedQueryRequest}`}
            >
              {row.values.vendor_name}
            </NavLink>
          );
        },
      },
      {
        // Header: "Overall Score",
        Header: `${currentMonthName} Score`,
        accessor: "score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.score`, 0)
                    ? parseFloat(getValue(row, `values.score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.score`, 0)
                ? getValue(row, `values.score`, 0)
                : 0}
              % */}
              {getValue(row, `values.score`, null) === null
                ? "- -"
                : `${getValue(row, `values.score`, 0)}%`}
            </div>
          );
        },
      },
      {
        // Header: "1MP Score",
        Header: `${prevMonth1Name} Score`,
        accessor: "prev_month_1_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_1_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_1_score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.prev_month_1_score`, 0) > 0
                ? `${getValue(row, `values.prev_month_1_score`, 0)}%`
                : "0%"} */}
              {getValue(row, `values.prev_month_1_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_1_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        // Header: "2MP Score",
        Header: `${prevMonth2Name} Score`,
        accessor: "prev_month_2_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_2_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_2_score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.prev_month_2_score`, 0) > 0
                ? `${getValue(row, `values.prev_month_2_score`, 0)}%`
                : "0%"} */}
              {getValue(row, `values.prev_month_2_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_2_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        // Header: "3MP Score",
        Header: `${prevMonth3Name} Score`,
        accessor: "prev_month_3_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_3_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_3_score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.prev_month_3_score`, 0) > 0
                ? `${getValue(row, `values.prev_month_3_score`, 0)}%`
                : "0%"} */}
              {getValue(row, `values.prev_month_3_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_3_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        Header: "Absent",
        accessor: "absent_sites",
        width: 100,
      },
      {
        Header: "Submited Checkpoint",
        accessor: "uploaded",
        width: 150,
      },
      {
        Header: "Not Submited Checkpoint",
        accessor: "not_uploaded",
        width: 160,
      },
      // {
      //   Header: "Submitted",
      //   accessor: "locations_all_submitted",
      //   width: 90,
      // },
      // {
      //   Header: "Partially Submitted",
      //   accessor: "locations_partial_submission",
      //   width: 130,
      // },
      // {
      //   Header: "Not Submitted",
      //   accessor: "locations_no_submission",
      //   width: 110,
      // },
      {
        Header: "Total Checkpoints",
        accessor: "total_checkpoint",
        width: 120,
      },

      {
        Header: "Headcount",
        accessor: "manpower",
        width: 80,
        Cell: ({ row }: any) => {
          return (
            <div className="headcount-button">
              {getValue(row, `values.manpower`, 0)
                ? numberFormatter(getValue(row, `values.manpower`, 0))
                : 0}
            </div>
          );
        },
      },

      {
        Header: "Action",
        width: 180,
        Cell: ({ row }: any) => {
          return (
            <>
              <div
                className="download-button"
                onClick={(e) =>
                  handleDownloadReport(
                    e,
                    row.original.vendor_id,
                    paramsNew.location_id
                  )
                }
              >
                Download Report
              </div>
              {getValue(props, `permissions`, []).includes(
                "download_vendor_zip"
              ) && (
                <div
                  className="download-button"
                  onClick={(e) =>
                    handleDownloadVendorAllCheckpointsDocs(
                      e,
                      row.original.vendor_id,
                      paramsNew.location_id
                    )
                  }
                >
                  Download Docs
                </div>
              )}
            </>
          );
        },
      },
    ],
    [paramsNew.date]
  );

  const handleDownloadVendorAllCheckpointsDocs = async (
    e: any,
    vendor_id: string,
    location_id: string
  ) => {
    e.stopPropagation();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    const payload = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      vendor_id: vendor_id,
      location_id: location_id,
      report_type: "VENDOR_CHECKPOINT_ALL_DOCS",
      report_name: `Vendor_Checkpoint_DOCS_ZIP_${currentDate()}`,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      const resp = await getVendorCheckpointsAllDocuments(queryRequest);
      // console.log("rrrrrrrrrrrrrrrrrr", res);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_CHECKPOINT_ALL_DOCS`);
      }
    } catch (e) {
      console.log("eeeeeeeeeeeeeeeeee", e);
    }
  };

  const handleDownloadReport = async (
    e: any,
    vendor_id: string,
    location_id: string
  ) => {
    e.stopPropagation();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload: any = {
        report_type: "VENDOR_AUDIT_SCORE",
        report_name: `vendor_audit_score_${currentDate()}`,
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: params.region_id,
        group_id: params.group_id,
        location_id: params.location_id,
        vendor_id: vendor_id,
        audit_type: params.audit_type,
      };
      payload.month = parseInt(payload.month);
      payload.region_id = parseInt(payload.region_id);

      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let resp = await generateManageAuditVendorReport(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE`);
      }
    } catch (error) {}
  };
  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminBulkLocationUpdateStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Date section                                 */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        ...params,
        date: dates,
      };

      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  const handleNavigate = (bodyObj: object) => {
    navigate(
      `/audit/details/${getValue(bodyObj, `vendor_id`, "")}/${moment(
        date
      ).format("YYYY-MM-DD")}/uploaded/${getValue(bodyObj, `vendor_name`, "")}`
    );
  };
  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let D = date ? date : new Date();
    let dates = params.date ? convertDate(params.date) : convertDate(D);
    let request = QueryRequestHelper({ ...params, date: dates });
    return request;
  };

  const mainQueryRequest = useMemo(
    () => urlParamsFun(),
    [window.location.href]
  );
  /* -------------------------------------------------------------------------- */
  /*                        smart Filter section                                */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    region_id: "",
    group_id: "",
    state_id: "",
    city_id: "",
    location_id: "",
    vendor_id: "",
    audit_type: "",
  });
  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    setRequest({
      ...request,
      state_id: "",
      city_id: "",
      region_id: "",
      group_id: "",
      location_id: "",
      vendor_id: "",
      audit_type: "",
    });
    setGroupsList([]);
    setStateList([]);
    setCityList([]);
    setlocationsList([]);
    setvendorsList([]);
    setAuditTypeList([]);
    //  setFilterVisibility(false);
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    setFilterVisibility(false);
  };

  const [isFilterVisible, setFilterVisibility] = React.useState(false);

  /* -------------------------------------------------------------------------- */
  /*                    smart Filter API section                                */
  /* -------------------------------------------------------------------------- */

  const [regionList, setRegionList] = useState([]);
  const [regionLoading, setRegionLoading] = useState(false);

  const getRegionsList = async (search_text: string, id: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        type: "REGION",
        search_text: search_text,
        region_id: id,
      };
      setRegionLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setRegionList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `region_id`, ""),
            label: getValue(item, `region_name`, ""),
            value: getValue(item, `region_name`, ""),
          }))
        );
        setRegionLoading(false);
      } else {
        setRegionLoading(false);
      }
    } catch (error) {
      setRegionLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   region_id: "",
      // });
      //   getGroupsList("", "");
      //   setGroupsList([]);
      //   getLocationsList("", "", "");
      //   setlocationsList([]);
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };

  const [groupsList, setGroupsList] = useState([]);
  const [groupLoading, setGroupLoading] = useState(false);
  const getGroupsList = async (
    search_text: string,
    region_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: params.region_id,
        type: "GROUP",
        search_text: search_text,
        group_id: id,
      };
      setGroupLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setGroupsList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            label: getValue(item, `group_name`, ""),
            value: getValue(item, `group_name`, ""),
          }))
        );
        setGroupLoading(false);
      } else {
        setGroupLoading(false);
      }
    } catch (error) {
      setGroupLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   group_id: null,
      // });
      //   getLocationsList("", "", "");
      //   setlocationsList([]);
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };
  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const getStatesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "STATE",
        search_text: search_text,
        state_id: id,
      };

      setStateLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setStateList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `state_id`, ""),
            label: getValue(item, `state_name`, ""),
            value: getValue(item, `state_name`, ""),
          }))
        );
        setStateLoading(false);
      } else {
        setStateLoading(false);
      }
    } catch (error) {
      setStateLoading(false);
    }
  };

  const [cityList, setCityList] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);
  const getCitiesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "CITY",
        search_text: search_text,
        state_id: state_id,
        city_id: id,
      };

      setCityLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setCityList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `city_id`, ""),
            label: getValue(item, `city_name`, ""),
            value: getValue(item, `city_name`, ""),
          }))
        );
        setCityLoading(false);
      } else {
        setCityLoading(false);
      }
    } catch (error) {
      setCityLoading(false);
    }
  };
  const [locationsList, setlocationsList] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const getLocationsList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "LOCATION",
        search_text: search_text,
        state_id: state_id,
        city_id: city_id,
        location_id: id,
      };
      setLocationLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setlocationsList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `location_id`, ""),
            label: getValue(item, `location_name`, ""),
            value: getValue(item, `location_name`, ""),
          }))
        );
        setLocationLoading(false);
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }

    if (search_text) {
      // setRequest({
      //   ...request,
      //   location_id: "",
      // });
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };

  const [vendorsList, setvendorsList] = useState([]);
  const [vendorLoading, setvendorLoading] = useState(false);
  const getVendorList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        type: "VENDOR",
        search_text: search_text,
        vendor_id: id,
      };
      setvendorLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setvendorsList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `vendor_id`, ""),
            label: getValue(item, `vendor_name`, ""),
            value: getValue(item, `vendor_name`, ""),
          }))
        );
        setvendorLoading(false);
      } else {
        setvendorLoading(false);
      }
    } catch (error) {
      setvendorLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   vendor_id: "",
      // });
    }
  };

  const [auditTypeList, setAuditTypeList] = useState([]);
  const [auditTypeLoading, setAuditTypeLoading] = useState(false);
  const getAuditTypeList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    vendor_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        vendor_id: vendor_id,
        type: "AUDIT_TYPE",
        search_text: search_text,
        audit_type: id,
      };
      setAuditTypeLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      let resp;
      if (resp) {
        setAuditTypeList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `audit_status`, ""),
            label: formatText(getValue(item, `audit_status`, "")),
            value: getValue(item, `audit_status`, ""),
          }))
        );
        setAuditTypeLoading(false);
      } else {
        setAuditTypeLoading(false);
      }
    } catch (error) {
      setAuditTypeLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   vendor_id: "",
      // });
    }
  };

  const handleRemoveFilter = (name: string) => {
    if (name === "region_id") {
      setRequest({
        ...request,
        region_id: "",
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      getRegionsList("", "");
      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "group_id") {
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getGroupsList("", getValue(params, `region_id`, ""), "");
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "state_id") {
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getStatesList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        ""
      );
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "city_id") {
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getCitiesList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        ""
      );
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "location_id") {
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      getLocationsList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        ""
      );
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "vendor_id") {
      setRequest({
        ...request,
        vendor_id: "",
        audit_type: "",
      });
      getVendorList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(params, `location_id`, ""),
        ""
      );
      setAuditTypeList([]);
    }
    if (name === "audit_type") {
      setRequest({
        ...request,
        audit_type: "",
      });
      getAuditTypeList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(params, `location_id`, ""),
        getValue(request, `vendor_id`, ""),
        ""
      );
    }
  };

  const handleSelectFilter = (id: any, name: string) => {
    if (name === "region_id") {
      getGroupsList("", id, "");
    }
    if (name === "group_id") {
      getStatesList("", getValue(params, `region_id`, ""), id, "");
    }

    if (name === "state_id") {
      getCitiesList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        id,
        ""
      );
    }

    if (name === "city_id") {
      getLocationsList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        id,
        ""
      );
    }

    if (name === "location_id") {
      getVendorList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        id,
        ""
      );
    }

    if (name === "vendor_id") {
      getAuditTypeList(
        "",
        getValue(params, `region_id`, ""),
        getValue(params, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(params, `location_id`, ""),
        id,
        ""
      );
    }

    setRequest({
      ...request,
      [name]: id,
    });
  };

  const handleSubmitSmartFilter = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      region_id: getValue(request, `region_id`, ""),
      group_id: getValue(request, `group_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      city_id: getValue(request, `city_id`, ""),
      location_id: getValue(request, `location_id`, ""),
      vendor_id: getValue(request, `vendor_id`, ""),
      audit_type: getValue(request, `audit_type`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
  };

  let state_ID =
    getValue(stateList, `length`, 0) > 0 &&
    stateList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );

  let city_ID =
    getValue(cityList, `length`, 0) > 0 &&
    cityList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `city_id`, "")
    );
  let region_ID =
    getValue(regionList, `length`, 0) > 0 &&
    regionList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `region_id`, "")
    );

  let group_ID =
    getValue(groupsList, `length`, 0) > 0 &&
    groupsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `group_id`, "")
    );

  let location_ID =
    getValue(locationsList, `length`, 0) > 0 &&
    locationsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `location_id`, "")
    );

  let vendor_ID =
    getValue(vendorsList, `length`, 0) > 0 &&
    vendorsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `vendor_id`, "")
    );

  let audit_type_ID =
    getValue(auditTypeList, `length`, 0) > 0 &&
    auditTypeList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `audit_type`, "")
    );

  /* -------------------------------------------------------------------------- */
  /*                               Chart section                                */
  /* -------------------------------------------------------------------------- */

  const handleChangeView = (view: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      view: view,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const [chartData, setChartData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Submitted",
        data: [0],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "Not Submitted",
        data: [0],
        backgroundColor: "rgba(200, 162, 255, 0.5)",
      },
      {
        label: "Total Checkpoints",
        data: [0],
        backgroundColor: "rgba(255, 199, 132, 0.5)",
      },
      {
        label: "Overall Score (%)",
        data: [0],
        backgroundColor: "rgba(255, 99, 132, 0.2)",
      },
    ],
  });

  const handleOnClickBarChart = (index: number) => {
    let selectedList = list.filter((_item: any, i: number) => index === i);
    let item = getValue(selectedList, `[${0}]`, "");

    const VendorId = getValue(item, `vendor_id`, "");
    const updatedQueryRequest = `${mainQueryRequest}&vendor_id=${VendorId}`;
    navigate(`/audit/manage-audit/checkpoint?${updatedQueryRequest}`);

    // navigate(
    //   `/audit/manage-audit/checkpoint/${getValue(
    //     mainParams,
    //     `region_id`,
    //     ""
    //   )}/${getValue(mainParams, `group_id`, "")}/${getValue(
    //     mainParams,
    //     `location_id`,
    //     ""
    //   )}/${getValue(item, `vendor_id`, "")}?${mainQueryRequest}`
    // );
  };

  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        labels: {
          value: {
            color: "black",
            font: {
              size: 13,
            },
          },
        },
        formatter: (val: any) => {
          // return val ? `${val}${val ? "%" : ""}` : "";
          return val;
        },
      },
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Vendor Level Breakup",
      },
    },
  };

  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      type: params.type ? params.type : "VENDOR",
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: true,
      user_id: getValue(user, `id`, ""),
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });

    let queryRequest = QueryRequestHelper(payload);
    setDownloadLoading(true);
    try {
      let resp = await exportManageAudit(queryRequest);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        handleDownloadOnClick(
          getValue(resp, `data.downloadUrl`, ""),
          "Manage Audit"
        );
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "audit_manage_audit"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              multi={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleRemoveNavItems={handleRemoveNavItems}
            />
          )}
          <div className="dashboard-wrapper__header d-flex justify-content-between d-none">
            <div className="d-flex align-items-center">
              <NavLink
                to={`/audit/manage-audit/location/${getValue(
                  mainParams,
                  `region_id`,
                  ""
                )}/${getValue(mainParams, `group_id`, "")}?${mainQueryRequest}`}
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid ml-5"
                  height={24}
                  width={24}
                />
              </NavLink>
              &nbsp;&nbsp;&nbsp;
              <h4 className="dashbaord-wrapper__header-title">
                Location -{" "}
                <span style={{ color: "#276ef2" }}>
                  {getValue(selectedOption, `location_name`, "")}
                </span>
              </h4>
            </div>
            <div className="d-flex align-items-center">
              <div
                className="d-flex cursor-pointer"
                onClick={() =>
                  handleChangeView(!getValue(params, `view`, "") ? "graph" : "")
                }
              >
                <img
                  src={`/images/${
                    getValue(params, `view`, "") === "graph"
                      ? "list"
                      : "bar_graph"
                  }.png`}
                  style={{ height: "30px", width: "30px", marginRight: "20px" }}
                />
              </div>
              <CalenderDropdown
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                disableDate
              />
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <NavLink
                // to={`/audit/manage-audit/location`}
                // to={`/audit/manage-audit/location?${(() => {
                //   // Get the current query string from the URL
                //   const currentParams = new URLSearchParams(window.location.search);

                //   // Remove the `region_id` parameter
                //   currentParams.delete("location_id");

                //   // Return the updated query string
                //   return currentParams.toString();
                // })()}`}
                to="#"
                onClick={(e: any) => {
                  e.preventDefault(); // Prevent default navigation behavior
                  window.history.back();
                }}
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid ml-5 me-2"
                  height={24}
                  width={24}
                />
              </NavLink>

              <div className="header-parent-icon-holder">
                <MenuAuditSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Manage Audit
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Sites -{" "}
                  <span style={{ color: "#276ef2" }}>
                    {getValue(selectedOption, `location_name`, "")}
                  </span>
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div
                className="d-flex cursor-pointer d-none"
                onClick={() =>
                  handleChangeView(!getValue(params, `view`, "") ? "graph" : "")
                }
              >
                <img
                  src={`/images/${
                    getValue(params, `view`, "") === "graph"
                      ? "list"
                      : "bar_graph"
                  }.png`}
                  style={{ height: "30px", width: "30px", marginRight: "20px" }}
                />
              </div>
              <RightMenuHeaders
                monthYear={true}
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={false}
                handleFilter={handleFilter}
                //Line Seperator of button
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
                // download section
                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
              />
            </div>
          </div>

          <div className="main-page-layout-wrapper">
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/location/detail"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  add="false"
                  isFilterVisible={isFilterVisible}
                />
              </div>
              {/* {isFilterVisible && ( */}
              <ManageAuditFilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                //region
                regionLoading={regionLoading}
                regionList={regionList}
                region_ID={region_ID}
                getRegionsList={getRegionsList}
                disableRegion
                //group
                groupLoading={groupLoading}
                groupsList={groupsList}
                group_ID={group_ID}
                getGroupsList={getGroupsList}
                disableGroup
                //state
                stateLoading={stateLoading}
                stateList={stateList}
                state_ID={state_ID}
                getStatesList={getStatesList}
                //city
                cityLoading={cityLoading}
                cityList={cityList}
                city_ID={city_ID}
                getCitiesList={getCitiesList}
                //location
                locationLoading={locationLoading}
                locationsList={locationsList}
                location_ID={location_ID}
                getLocationsList={getLocationsList}
                disableLocation
                //configuration/vendors
                vendorLoading={vendorLoading}
                vendorsList={vendorsList}
                vendor_ID={vendor_ID}
                getVendorList={getVendorList}
                //audit_type
                auditTypeLoading={auditTypeLoading}
                auditTypeList={auditTypeList}
                audit_type_ID={audit_type_ID}
                getAuditTypeList={getAuditTypeList}
                //above common funs
                request={request}
                handleSelectFilter={handleSelectFilter}
                handleRemoveFilter={handleRemoveFilter}
                hideReset
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                moduleName={"Audit"}
                subModuleName={"Manage Audit - Location"}
              />
              {/* )} */}
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <>
                  {getValue(params, `view`, "") === "graph" ? (
                    <div className="manage_audit_chart-view">
                      <Bar
                        data={chartData}
                        options={{
                          ...options,
                          responsive: true,
                          maintainAspectRatio: true,
                          onClick: function (evt, element) {
                            let ind = getValue(element, `[${0}].index`, null);
                            if (element.length > 0) {
                              handleOnClickBarChart(ind);
                            }
                          },
                        }}
                      />
                    </div>
                  ) : (
                    <ScrollableReactTable
                      columns={columns}
                      data={list}
                      getTableState={getTableState}
                      rowClick={rowClick}
                      check={check}
                      selectedIDs={selectedIDs}
                      getTrProps={getTrProps}
                      checkboxlogo
                    />
                  )}
                </>
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <ManageAuditNotfound />
                    </>
                  ) : (
                    <ManageAuditNotfound />
                  )}
                </>
              )}
            </div>
            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
              hideCount
            />
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default ManageAuditVendor;
